import { axiosV2 } from "config/@axios";
import * as uiActions from "store/actions/uiActions";

import i18next from "i18next";

export const FETCH_CONTACTS_PENDING = "Contacts->uiActions::pendingContacts";
export const FETCH_CONTACTS_SUCCESS =
  "Contacts->uiActions::fetchContactsSuccess";
export const FETCH_CONTACTS_FAILED = "Contacts->uiActions::fetchContactsFailed";
export const REDIRECT_CONTACT = "Contacts->uiActions::redirectContact";

export const ADD_CONTACT = "Contacts->uiActions::addContact";
export const UPDATE_CONTACT = "Contacts->uiActions::updateContact";
export const UPDATE_CONTACT_SUCCESS =
  "Contacts->uiActions::updateContactSuccess";
export const UPDATE_CONTACT_FAILED = "Contacts->uiActions::updateContactFailed";
export const DELETE_CONTACT = "Contacts->uiActions::deleteContact";
export const DELETE_CONTACT_SUCCESS =
  "Contacts->uiActions::deleteContactSuccess";
export const DELETE_CONTACT_FAILED = "Contacts->uiActions::deleteContactFailed";
export const GET_CONTACT = "Contacts->uiActions::getContact";
export const SET_DELETE_CONTACT_MODAL =
  "Contacts->uiActions::setDeleteContactModal";
export const CLOSE_CONTACT_DELETE_MODAL =
  "Contacts->uiActions::closeContactDeleteModal";

export const SELECT_ALL = "Contacts->uiActions::SelectAll";
export const SELECT_SINGLE = "Contacts->uiActions::SelectSingle";

export const fetchContacts = params => dispatch => {
  dispatch({
    type: FETCH_CONTACTS_PENDING
  });
  return axiosV2
    .get("contacts", {
      params
    })
    .then(response => {
      const xMore = parseInt(response?.headers?.["x-more"]);
      dispatch({
        type: FETCH_CONTACTS_SUCCESS,
        payload: {
          contacts: response.data,
          hasMore: !!xMore,
          isStart: params?.start === 0
        }
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_CONTACTS_FAILED,
        payload: err?.errorMessage
      });
    });
};

export const addContact = payload => {
  const data = { ...payload, timestamp: new Date().getTime() };
  return {
    type: ADD_CONTACT,
    payload: data
  };
};

export const updateContact = payload => {
  const data = { ...payload, timestamp: new Date().getTime() };

  return {
    type: UPDATE_CONTACT,
    payload: data
  };
};
export const redirectContact = payload => {
  return {
    type: REDIRECT_CONTACT,
    payload
  };
};

// Items of a _bulk answer that failed: [{ contact_id, status: "error", message }]
const failedBulkItems = response =>
  (Array.isArray(response?.data) ? response.data : []).filter(
    item => item?.status === "error"
  );

// Known item codes get the same text as a failed request with that code
const bulkErrorMessage = item => {
  if (!item.code) {
    return item.message;
  }

  const key = `generic:errors.${String(item.code).replace(/\./g, "*")}`;
  return i18next.exists(key) ? i18next.t(key) : item.message;
};

export const deleteContact = (contactIds, referer) => dispatch => {
  const mappedIds = contactIds.map(contact_id => ({
    contact_id: contact_id.toString()
  }));
  return axiosV2
    .post(`/contacts/_bulk`, {
      action: "delete",
      data: mappedIds
    })
    .then(response => {
      // _bulk answers 200 even when some contacts could not be deleted (e.g.
      // a read-only shared address book); those stay in the list
      const failed = failedBulkItems(response);
      const failedIds = failed.map(item => String(item.contact_id));
      const deletedIds = contactIds.filter(
        id => !failedIds.includes(String(id))
      );

      dispatch({
        type: DELETE_CONTACT_SUCCESS,
        payload: deletedIds
      });
      dispatch(
        uiActions.addSnackbar({
          message:
            failed.length > 0
              ? bulkErrorMessage(failed[0])
              : i18next.t("contacts:messages.success_message")
        })
      );
      setDeleteContactModal({
        deleteContactIds: null,
        deleteContactNameOrCount: null,
        deleteContactReferer: null
      });
      selectAll(false);
    })
    .catch(err => {
      dispatch({
        type: DELETE_CONTACT_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const updateContactTagsBulk = (contactIds, tags) => dispatch => {
  const mappedIds = contactIds.map(contact_id => ({
    contact_id: contact_id.toString(),
    parameters: {
      tags: tags
    }
  }));
  return axiosV2
    .post(`/contacts/_bulk`, {
      action: "update",
      data: mappedIds
    })
    .then(response => {
      const failed = failedBulkItems(response);

      dispatch(
        uiActions.addSnackbar({
          message:
            failed.length > 0
              ? bulkErrorMessage(failed[0])
              : i18next.t("contacts:messages.tag_bulk_update_success")
        })
      );
      selectAll(false);
    })
    .catch(err => {
      dispatch({
        type: UPDATE_CONTACT_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const getContact = id => {
  return {
    type: GET_CONTACT,
    payload: id
  };
};
export const setDeleteContactModal = payload => {
  return {
    type: SET_DELETE_CONTACT_MODAL,
    payload
  };
};
export const closeContactDeleteModal = payload => {
  return {
    type: CLOSE_CONTACT_DELETE_MODAL,
    payload
  };
};

export const selectAll = isSelected => (dispatch, getState) => {
  const { contacts } = getState();
  let list = contacts.entities.contacts.allIds;

  dispatch({
    type: SELECT_ALL,
    payload: {
      isSelected,
      list
    }
  });
};

export const selectSingle = (id, isSelected) => ({
  type: SELECT_SINGLE,
  payload: {
    id,
    isSelected
  }
});

export const CLEAR_ERROR = "Contacts->uiActions::clearError";

export const clearError = () => ({
  type: CLEAR_ERROR
});
